import { Directive } from '@angular/core';

export interface IProgessBarWizardComponent {
    get CanStepForward(): boolean;
    get ShowContentBorder(): boolean;

    UpdateWizardState(): void;
    SetWizardState(state: any): void;
}

@Directive()
export abstract class AProgessBarWizardComponent implements IProgessBarWizardComponent {
    WizardState: any = {};

    CanStepForwardValue = false;
    get CanStepForward(): boolean {
        return this.CanStepForwardValue;
    }
    ShowContentBorderValue = false;
    get ShowContentBorder(): boolean {
        return this.ShowContentBorderValue;
    }
    UpdateWizardState(): void {
    }
    SetWizardState(state: any): void {
        if (state) {
            this.WizardState = state;
            this.OnWizardStateSet();
        }
    }    
    OnWizardStateSet(): void {
    }
}

export class StepForwardResult {
    CanStepForward: boolean;
}

export enum ProgressBarWizardButtonAlignment {
    Left,
    Right,
    Separated
}
